const customRestrictions = {};
// restituisce il carattere descritto nell'evento come codice
const getEventKeyChar = (event) => {
    if (!event.type || event.type === 'keypress') {
        return String.fromCharCode(event.which || event.keyCode);
    }
    return event.key;
};
// controlla se l'evento soddisfa la restrizione passata come parametro keyName
const matchKeyboardEvent = (event, keyName) => {
    const cleanKeyName = keyName.toLowerCase().trim();
    const customRestriction = customRestrictions[cleanKeyName] || null;
    if (event.ctrlKey) {
        return true;
    }
    if (customRestriction) {
        return customRestriction.restriction(event);
    }
    return keyName === getEventKeyChar(event);
};
// verifica che sia soddisfatta almeno una regola di restrizione passata in keys
const findMatchedKey = (event, keys) => keys.find((k) => matchKeyboardEvent(event, k));
var DefaultRestrictionsEnums;
(function (DefaultRestrictionsEnums) {
    DefaultRestrictionsEnums["numeri"] = "numeri";
    DefaultRestrictionsEnums["numerinegativi"] = "numerinegativi";
    DefaultRestrictionsEnums["numeridecimali"] = "numeridecimali";
    DefaultRestrictionsEnums["numeridecimalinegativi"] = "numeridecimalinegativi";
    DefaultRestrictionsEnums["lettere"] = "lettere";
    DefaultRestrictionsEnums["lettereall"] = "lettereall";
    DefaultRestrictionsEnums["alfanumerici"] = "alfanumerici";
    DefaultRestrictionsEnums["cognomenome"] = "cognomenome";
    DefaultRestrictionsEnums["ragionesociale"] = "ragionesociale";
    DefaultRestrictionsEnums["codicefiscale"] = "codicefiscale";
})(DefaultRestrictionsEnums || (DefaultRestrictionsEnums = {}));
const DefaultRestrictions = DefaultRestrictionsEnums;
const Restriction = {
    register(name, func) {
        customRestrictions[name.toLowerCase()] = { restriction: func };
    },
    isValid(event, handleKeys) {
        return !!findMatchedKey(event, handleKeys);
    },
    DefaultValues: DefaultRestrictions,
};
const numberKeys = '0123456789'.split('');
const letterKeys = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
const letterSpecialKeys = 'äâàçèéêëìîïíñòôóöûùüúÁÀÂÄÇÈÉÊËÌÎÏÍÑÔÖÒÙÛÜÓÚß'.split('');
const allLetterKeys = [...letterKeys, ...letterSpecialKeys];
const alphanumericKeys = [...numberKeys, ...allLetterKeys];
Restriction.register(DefaultRestrictionsEnums.numeri, (event) => numberKeys.indexOf(getEventKeyChar(event)) !== -1);
Restriction.register(DefaultRestrictionsEnums.numerinegativi, (event) => {
    const char = getEventKeyChar(event);
    return numberKeys.indexOf(char) !== -1 || char === '-';
});
Restriction.register(DefaultRestrictionsEnums.numeridecimali, (event) => {
    const char = getEventKeyChar(event);
    return numberKeys.indexOf(char) !== -1 || char === '.' || char === ',';
});
Restriction.register(DefaultRestrictionsEnums.numeridecimalinegativi, (event) => {
    const char = getEventKeyChar(event);
    return numberKeys.indexOf(char) !== -1 || char === '-' || char === '.' || char === ',';
});
Restriction.register(DefaultRestrictionsEnums.lettere, (event) => letterKeys.indexOf(getEventKeyChar(event)) !== -1);
Restriction.register(DefaultRestrictionsEnums.lettereall, (event) => allLetterKeys.indexOf(getEventKeyChar(event)) !== -1);
Restriction.register(DefaultRestrictionsEnums.alfanumerici, (event) => alphanumericKeys.indexOf(getEventKeyChar(event)) !== -1);
Restriction.register(DefaultRestrictionsEnums.cognomenome, (event) => {
    const char = getEventKeyChar(event);
    return allLetterKeys.indexOf(char) !== -1 || char === '\'' || char === '`' || char === ' ';
});
Restriction.register(DefaultRestrictionsEnums.ragionesociale, (event) => {
    const char = getEventKeyChar(event);
    return alphanumericKeys.indexOf(char) !== -1 || char === '\'' || char === '`'
        || char === '&' || char === ' ' || char === '-' || char === '_';
});
Restriction.register(DefaultRestrictionsEnums.codicefiscale, (event) => {
    const char = getEventKeyChar(event);
    return letterKeys.indexOf(char) !== -1 || numberKeys.indexOf(char) !== -1;
});

export { DefaultRestrictionsEnums, Restriction as default };
